import { Component, ElementRef, EventEmitter, Input, Output, Renderer2, ViewChild } from '@angular/core';
import { BodyRequest, ItemType } from '../formulario/request.model';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { tieneFoto } from '../../core/foto.util';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-item',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './item.component.html',
  styleUrl: './item.component.scss'
})
export class ItemComponent {
  ItemType = ItemType;
  filesBasePath = environment.FILES_BASE_PATH;
  tieneFoto = tieneFoto;
  
  @Input()
  item!: any;

  @Input()
  type!: ItemType;

  /** Tarjeta de solo identidad (foto y nombre): muestra la foto, oculta el ID y se abre con Enter. Las demás listas no cambian. */
  @Input()
  soloIdentidad = false;

  /** La foto no se ha podido cargar: se muestra la imagen por defecto. */
  fotoRota = false;

  @Output()
  openItem = new EventEmitter<BodyRequest>();

  @Output()
  deleteItem = new EventEmitter<BodyRequest>();

  notShowViewButton: ItemType[] = [];
  notShowImg: ItemType[] = [ItemType.EJERCICIOS, ItemType.CARGOS];

  @ViewChild('miDiv') cardElementItem!: ElementRef;

  constructor(
    private router: Router,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    
  }

  goTo() {
    this.router.navigateByUrl(`${this.type.toLowerCase()}/${this.item.id}`)
  }

}
